import CarePlanCard from './CarePlanCard';
import { useLanguage } from '../../contexts/LanguageContext';
import { sortCarePlans } from '../../utils/carePlan';

export default function CarePlansTab({
  carePlans = [],
  onAddAddendum,
  onResolve,
  onExportPdf,
  resolvingId = null,
  savingAddendumId = null,
}) {
  const { t } = useLanguage();
  const sorted = sortCarePlans(carePlans);

  if (!sorted.length) {
    return (
      <p className="py-6 text-center text-sm text-gray-500">
        {t('noCarePlansYet')}
      </p>
    );
  }

  return (
    <div className="space-y-3">
      {sorted.map((carePlan) => (
        <CarePlanCard
          key={carePlan.id}
          carePlan={carePlan}
          onAddAddendum={onAddAddendum}
          onResolve={onResolve}
          onExportPdf={onExportPdf}
          resolving={resolvingId === carePlan.id}
          savingAddendum={savingAddendumId === carePlan.id}
        />
      ))}
    </div>
  );
}
